import DashboardPIM from '../../Interfaces/PIMs/DashboardPIM';
import DashboardSearchPIM from '../../Interfaces/PIMs/DashboardSearchPIM';
import { SD_SPNameList } from '../../Utility/StaticDatas';
import baseApi from '../baseApi';

const baseUrl = `/AuthDataGet/ExecuteJson/${SD_SPNameList.DB_SP_Dashboard}`;

const SPDashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdmissionByDate: builder.query({
      query: () => ({ url: `${baseUrl}/1`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getStudentDataByDate: builder.query({
      query: (data: DashboardPIM) => ({
        url: `${baseUrl}/4`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['dashboard'],
    }),
    getSearchResult: builder.mutation({
      query: (data: DashboardSearchPIM) => ({
        url: `${baseUrl}/7`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['dashboard'],
    }),
    getActivetionKeyDate: builder.query({
      query: () => ({ url: `${baseUrl}/8`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getVideoReport: builder.query({
      query: (data: {
        tblStudentPackageHistory: { FromDate: string; ToDate: string };
      }) => ({
        url: `${baseUrl}/9`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['dashboard'],
    }),
    getStudentRegisterData: builder.query({
      query: () => ({ url: `${baseUrl}/10`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    insertDashboardCardPermission: builder.mutation({
      query: (data: { AssignedUserId: string; ServiceIds: string }) => ({
        url: `${baseUrl}/11`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['dashboard'],
    }),
    getDashboardCardPermission: builder.mutation({
      query: (data: { AssignedUserId: string }) => ({
        url: `${baseUrl}/12`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['dashboard'],
    }),
    getStudentChatCount: builder.query({
      query: () => ({ url: `${baseUrl}/13`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getPendingEmiByDate: builder.query({
      query: (data: { SearchedDate?: string }) => ({
        url: `${baseUrl}/16`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['dashboard'],
    }),
    getNotification: builder.query({
      query: () => ({ url: `${baseUrl}/15`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getPackagesByUser: builder.query({
      query: (data: { StudentUserId: string }) => ({
        url: `${baseUrl}/17`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['dashboard'],
    }),
    getVideoSpendingTime: builder.query({
      query: () => ({ url: `${baseUrl}/18`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getLiveSpendingTime: builder.query({
      query: () => ({ url: `${baseUrl}/19`, method: 'POST', body: {} }),
      providesTags: ['dashboard'],
    }),
    getActivationKeyDetailsOfStudent: builder.query({
      query: (data) => ({
        url: `${baseUrl}/20`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['dashboard'],
    }),
    deleteNonRegisterStudent: builder.mutation({
      query: (data) => ({
        url: `${baseUrl}/21`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['dashboard'],
    }),
    unassignListDashboard: builder.query({
      query: (data) => ({ url: `${baseUrl}/22`, method: 'POST', body: data }),
      providesTags: ['dashboard'],
    }),
    getAllStudentSearchResult: builder.mutation({
      query: (data: DashboardSearchPIM) => ({
        url: `${baseUrl}/23`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['dashboard'],
    }),
  }),
});

export const {
  useGetAdmissionByDateQuery,
  useGetNotificationQuery,
  useGetSearchResultMutation,
  useGetActivetionKeyDateQuery,
  useGetStudentDataByDateQuery,
  useGetVideoReportQuery,
  useGetStudentRegisterDataQuery,
  useInsertDashboardCardPermissionMutation,
  useGetDashboardCardPermissionMutation,
  useGetStudentChatCountQuery,
  useGetPendingEmiByDateQuery,
  useGetPackagesByUserQuery,
  useGetVideoSpendingTimeQuery,
  useGetLiveSpendingTimeQuery,
  useGetActivationKeyDetailsOfStudentQuery,
  useDeleteNonRegisterStudentMutation,
  useUnassignListDashboardQuery,
  useGetAllStudentSearchResultMutation,
} = SPDashboardApi;

export default SPDashboardApi;
